import React from 'react';
import Typography from '@visa/vds/typography';
import Grid from '@visa/vds/grid';
import MCSSpace from '../../components/MCSSpace';
import PagePic from '../../_imgs/illustrations/spotlight/illustration-spotlight-fraud-dark.svg';

const Forbidden = (props) => {
    return (
        <Grid>
            <MCSSpace height="50px" />
            <Typography style={{ textAlign: "center", margin: "auto" }} tag="h1">Forbidden Access</Typography>
            <MCSSpace />
            <img style={{ width: "280px", margin: "auto" }} src={PagePic} />
            <MCSSpace />
        </Grid>
    );
}

export default Forbidden;
